export default __webpack_public_path__ + "static/media/drinks, coffee & tea_cat.dc81fb84.jpg";